/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { Map, Set } from 'immutable';

class ErrorSet {

  static createEmpty() {
    return new ErrorSet();
  }

  constructor(errors = Set()) {
    this.errors = errors;
  }

  add(code, target, args = {}) {
    let errors = this.errors;
    const error = this.errors.find(e => e.get('target') === target);
    if (error) {
      errors = errors.remove(error);
    }
    return new ErrorSet(errors.add(Map({ code, target, ...args })));
  }

  has(target) {
    return this.errors.some(e => e.get('target') === target);
  }

  remove(target) {
    const error = this.errors.find(e => e.get('target') === target);
    if (error) {
      return new ErrorSet(this.errors.remove(error));
    }
    return this;
  }

  get(target) {
    return this.errors.find(e => e.get('target') === target);
  }

  getCode(target) {
    const error = this.get(target);
    if (error) {
      return error.get('code');
    }
    return null;
  }

  getArg(target, arg) {
    const error = this.get(target);
    if (error) {
      return error.get(arg);
    }
    return null;
  }

  isEmpty() {
    return this.errors.isEmpty();
  }
}

export default ErrorSet;




// WEBPACK FOOTER //
// ./src/utils/errors/ErrorSet.js